import { AccountType } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';
import { Control } from 'react-hook-form';

import AutocompleteAccountsTypeahead from '~components/FormFields/CommonAutocompletes/AutocompleteAccountsTypeahead';
import AutocompleteDriversTypeahead from '~components/FormFields/CommonAutocompletes/AutocompleteDriversTypeahead';

import { CommissionDefaultFormValues } from './commissionDefaultSchema';

interface Props {
  companyId: string;
  control: Control<CommissionDefaultFormValues>;
  isDisabled?: boolean;
  isDriver: boolean;
}

export default function CommissionPayeeSelector({
  companyId,
  control,
  isDisabled,
  isDriver,
}: Props) {
  if (isDriver) {
    return (
      <AutocompleteDriversTypeahead
        key="driver"
        companyId={companyId}
        control={control}
        isDisabled={isDisabled}
        isRequired
        shared={false}
        label={<label htmlFor="payee">{t('pay_commission_defaults.driver')}</label>}
        name="payee"
      />
    );
  }

  return (
    <AutocompleteAccountsTypeahead
      key="vendor"
      accountTypes={[AccountType.VENDOR]}
      companyId={companyId}
      control={control}
      isDisabled={isDisabled}
      isRequired
      label={<label htmlFor="payee">{t('pay_commission_defaults.vendor')}</label>}
      name="payee"
    />
  );
}
